import API from '@/models/API';

export default class Customers {
  constructor(item = {}) {
    this.user_account_id = item.user_account_id || null;
    this.user_id = item.user_id || null;
    this.first_name = item.first_name || '';
    this.last_name = item.last_name || '';
    this.card_numbers = item.card_numbers || null;
    this.card_number = item.card_number || null;
    this.source = item.source || null;
    this.app_provider_id = item.app_provider_id || null;
    this.store_id = item.store_id || null;
    this.gender = item.gender || '';
    this.zipcode = item.zipcode || '';
    this.address = item.address || '';
    this.country_id = item.country_id || null;
    this.county_id = item.county_id || null;
    this.email = item.email || '';
    this.mobile = item.mobile || '';
    this.phone = item.phone || '';
    this.marketing = item.marketing || false;
    this.birth_date = item.birth_date || '';
    this.form_date = item.form_date || '';
    this.notifications = item.notifications || {
      sms: false,
      push: false,
      mail: false,
    };
    this.extra_attributes = item.extra_attributes || [];
  }

  static get = (query, filters) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/customers${query + filters}`);

  static getCustomerProfile = (id) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/customers/${id}`);

  static create = (customer) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/customers/create`, customer);

  static cardSearch = (params) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/customers/card-search`, { params });

  static customerDetails = (id) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/customers/${id}`);

  static customerUpdate = (customer) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/customers/${customer.user_account_id}`,
      customer
    );

  static getStores = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/company-stores${query}`);

  static mergeUsers = (body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/customers/merge-accounts-by-mobiles`,
      body
    );

  static getTransactions = (id, q) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/customers/${id}/transactions${q}`);

  static addNewCardNumber = (body) =>
    API.post(`/companies/${body.company_id}/customers/${body.user_account_id}/loyalty-card`, {
      card_number: body.card_number,
    });

  static updateMobile = (body) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/customers/update-mobile/${body.user_account_id}`,
      {
        mobile: body.mobile,
      }
    );

  static removePoints = (id) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/customers/${id}/remove-points`);

  static detachCard = (id, body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/customers/detach-card/${id}`, body);

  static importCustomers = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/customers/import/`, body);

  static getAttributes = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/attributes/definitions${query}`);

  static createAttribute = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/attributes/definitions/`, body);

  static updateAttribute = (id, body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/attributes/definitions/${id}`, body);

  static deleteAttribute = (id) =>
    API.delete(`/companies/${localStorage.getItem('storeId')}/attributes/definitions/${id}`);

  static deleteCustomer = (id) =>
    API.delete(`/companies/${localStorage.getItem('storeId')}/customers/${id}`);

  static doAdjustPoints(id, body) {
    return API.post(
      `/companies/${localStorage.getItem('storeId')}/customers/${id}/points/adjust`,
      body
    );
  }
  static redeemCoupons(id, body) {
    return API.post(
      `/companies/${localStorage.getItem('storeId')}/customers/${id}/gifts/claim-and-redeem`,
      body
    );
  }
  static fetchUserPoints(id, body) {
    return API.get(
      `/companies/${localStorage.getItem('storeId')}/customers/${id}/points?include_missing=true`,
      body
    );
  }
  static updateCustomAttributes = (id, body) => {
    return API.patch(
      `/companies/${localStorage.getItem('storeId')}/customers/${id}/attributes`,
      body
    );
  };

  static updateCustomerAttribute = (user_account_id, attribute_definition_id, body) => {
    return API.patch(
      `/companies/${localStorage.getItem('storeId')}/customers/${user_account_id}/attribute/${attribute_definition_id}`,
      body
    );
  };

  static deleteCustomerAttribute = (user_account_id, attribute_definition_id, value_id) => {
    return API.delete(
      `/companies/${localStorage.getItem('storeId')}/customers/${user_account_id}/attribute/${attribute_definition_id}/value/${value_id}`
    );
  };
}
